import { render, staticRenderFns } from "./HeaderButtonSeparator.vue?vue&type=template&id=413f2de4"
import script from "./HeaderButtonSeparator.vue?vue&type=script&lang=js"
export * from "./HeaderButtonSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports